import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={20}
    height={20}
    viewBox="0 0 64 64"
    {...props}
  >
    <path
      fill="#ffffff" 
      d="M60 28c0-8.301-5.016-24-24-24h-8C9.016 4 4 19.699 4 28c-2.211 0-4 1.789-4 4v16c0 2.211 1.789 4 4 4h4v4c0 2.211 1.789 4 4 4h4c2.211 0 4-1.789 4-4v-4h24v4c0 2.211 1.789 4 4 4h4c2.211 0 4-1.789 4-4v-4h4c2.211 0 4-1.789 4-4V32c0-2.211-1.789-4-4-4zM16 44c-2.211 0-4-1.789-4-4s1.789-4 4-4 4 1.789 4 4-1.789 4-4 4zm-4-16c0-.652.184-16 16-16h8c15.41 0 15.984 14.379 16 16H12zm36 16c-2.211 0-4-1.789-4-4s1.789-4 4-4 4 1.789 4 4-1.789 4-4 4z"
    />
  </svg>
)
export default SvgComponent